//Serviços
import { Axios } from "../../service/serviceBasic";
import { converterObjActionForObjReduceFormEndereco } from "../../helper/converter";

//Tipos
import {
  SET_ENDERECO_PAIS,
  LOADING_ENDERECO_PAIS,
  ERROR_ENDERECO_PAIS,
  SET_ENDERECO_ESTADO,
  LOADING_ENDERECO_ESTADO,
  ERROR_ENDERECO_ESTADO,
  SET_ENDERECO_CEP,
  LOADING_ENDERECO_CEP,
  ERROR_ENDERECO_CEP,
  CHANGE_ENDERECO_VALUE_FORM,
  HANDLER_CHANGE_TYPEAHEAD,
  SET_ID_DDIPAIS_ENDERECO
} from "./types";

//Recebendo lista dos países para o typearead =====================================================
const loadingListEnderecoPaisAction = (flag) => ({
  type: LOADING_ENDERECO_PAIS,
  payload: flag,
});
const setListEnderecoPaisAction = (list) => ({
  type: SET_ENDERECO_PAIS,
  payload: list,
});
const setErrorListEnderecoPais = (message) => ({
  type: ERROR_ENDERECO_PAIS,
  payload: message,
});

export const getListEnderecoPaisAction = () => (dispatch, getState) => {
  dispatch(loadingListEnderecoPaisAction(true));
  return Axios.post("v1/basico/pais/list", {})
    .then((response) => {
      dispatch(setListEnderecoPaisAction(response.data));
    })
    .catch((error) => {
      dispatch(setErrorListEnderecoPais(error.message));
    })
    .finally(() => {
      dispatch(loadingListEnderecoPaisAction(false));
    });
};

//Recebendo lista dos estados para o typearead ===============================================
const loadingListEnderecoEstadoAction = (flag) => ({
  type: LOADING_ENDERECO_ESTADO,
  payload: flag,
});
const setListEnderecoEstadoAction = (list) => ({
  type: SET_ENDERECO_ESTADO,
  payload: list,
});
const setErrorListEnderecoEstado = (message) => ({
  type: ERROR_ENDERECO_ESTADO,
  payload: message,
});

export const getListEnderecoEstadoAction = (IdPais) => (dispatch) => {
  dispatch(loadingListEnderecoEstadoAction(true));
  return Axios.post("v2/basico/estado/list", { IdPais: IdPais })
    .then((response) => {
      let list = [];
      response.data.forEach((element, index, array) => {
        list.push({ ...element, IdEstado: element.IdEstado.toString() });
      });

      dispatch(setListEnderecoEstadoAction(list));
    })
    .catch((error) => {
      dispatch(setErrorListEnderecoEstado(error.message));
    })
    .finally(() => {
      dispatch(loadingListEnderecoEstadoAction(false));
    });
};

//Recebendo objeto com as informacções de endereço do CEP para o form ===============================================
const loadingObjEnderecoCEPAction = (flag) => ({
  type: LOADING_ENDERECO_CEP,
  payload: flag,
});
const setObjEnderecoCEPAction = (obj) => ({
  type: SET_ENDERECO_CEP,
  payload: obj,
});
const setErrorObjEnderecoCEP = (message) => ({
  type: ERROR_ENDERECO_CEP,
  payload: message,
});

export const getObjEnderecoCEPAction = (formEnderecoValues) => (
  dispatch,
  getState
) => {
  let CEP = formEnderecoValues.endereco_cep;
  // eslint-disable-next-line no-useless-escape
  CEP = CEP.replace(/\/|\-|\.|\(|\)/g, "");

  dispatch(loadingObjEnderecoCEPAction(true));
  return Axios.post("v1/cliente/endereco/buscar", { CEP })
    .then((response) => {
      let objResponse = converterObjActionForObjReduceFormEndereco(
        response.data,
        formEnderecoValues
      );
      let { enderecoReducer } = getState();

      dispatch(setObjEnderecoCEPAction(objResponse));

      if (enderecoReducer.typeaHeadEnderecoEstadoList.length > 0) {
        var estado = enderecoReducer.typeaHeadEnderecoEstadoList.find(function (
          element
        ) {
          return element.IdEstado === response.data.IdEstado.toString();
        });

        if (estado) {
          estado.IdEstado = estado.IdEstado.toString();
          dispatch({
            type: HANDLER_CHANGE_TYPEAHEAD,
            payload: { value: estado.IdEstado, name: "endereco_estado" },
          });
        }
      }
    })
    .catch((error) => {
      dispatch(setErrorObjEnderecoCEP(error.message));
    })
    .finally(() => {
      dispatch(loadingObjEnderecoCEPAction(false));
    });
};

//Adicionando valores dos forms as variáveis do reduce ======================================
export const changeEnderecoValueForm = (name, value) => (
  dispatch,
  getState
) => {
  let { enderecoReducer } = getState();
  let formEnderecoValues = enderecoReducer.formEndereco;

  formEnderecoValues[name] = value;
  // eslint-disable-next-line no-useless-escape
  //let cep = value.replace(/\/|\-|\.|\(|\)/g, "");
  if (
    name === "endereco_cep" &&
    value.replace(/\/|-|\.|\(|\)/g, "").length === 8 &&
    enderecoReducer.endereco_pais === "BRA"
  ) {
    dispatch(getObjEnderecoCEPAction(formEnderecoValues));
  } else {
    dispatch({
      type: CHANGE_ENDERECO_VALUE_FORM,
      payload: formEnderecoValues,
    });
  }
};

//Adicionando o valor do typeahead a variável===================================================
export const handleChangeTypeahead = (data) => (dispatch, getState) => {
  let { enderecoReducer } = getState();

  let { value, name } = data;
  let endereco = { ...enderecoReducer };

  if (endereco.endereco_pais !== value) {
    if (name === "endereco_pais") {
      const estado = { value: "", name: "endereco_estado" };
      dispatch({
        type: HANDLER_CHANGE_TYPEAHEAD,
        payload: estado,
      });

      endereco[name] = value;
      dispatch(getListEnderecoEstadoAction(endereco[name]));
    }
  }

  dispatch({
    type: HANDLER_CHANGE_TYPEAHEAD,
    payload: data,
  });
};

export const setIdDDIPaisEndereco= (id) => dispatch => {
  dispatch({
    type: SET_ID_DDIPAIS_ENDERECO,
    payload: id,
  }); 
}

